import { render, staticRenderFns } from "./mobileTable.vue?vue&type=template&id=a86f2208&scoped=true"
import script from "./mobileTable.vue?vue&type=script&lang=js"
export * from "./mobileTable.vue?vue&type=script&lang=js"
import style0 from "./mobileTable.vue?vue&type=style&index=0&id=a86f2208&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86f2208",
  null
  
)

export default component.exports